<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="50%"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="close"
      @open="open"
    >
      <el-form :model="form_community" label-position="top">
        <el-form-item label="Title" prop="title">
          <el-input type="text" v-model="form_community.title" clearable />
        </el-form-item>
        <el-form-item  label="Featured" prop="featured">
          <el-switch
            v-model="form_community.featured"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="Yes"
            inactive-text="No"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="Role" prop="role">
          <el-input type="text" v-model="form_community.role" clearable />
        </el-form-item>
        <el-form-item label="Name" prop="name">
          <el-input type="text" v-model="form_community.name" clearable />
        </el-form-item>
        <div>
          <p class="inline-eye">Quote</p>
          <i
            class="el-icon-view ml10"
            @click="openPreview(form_community.quote)"
          ></i>
        </div>
        <el-form-item prop="text">
          <vue-editor
            v-model="form_community.quote"
            :editorToolbar="customToolbar"
          />
        </el-form-item>
        <el-form-item label="Post" prop="post_link">
          <el-input type="text" v-model="form_community.post_link" clearable />
        </el-form-item>
        <el-form-item label="Position" prop="position">
          <el-input type="number" v-model="form_community.position" clearable />
        </el-form-item>
        <p>Image</p>
        <el-upload
          :action="`${url}cms/community/upload`"
          :headers="headers"
          accept="image/*"
          :on-success="onSuccess"
          :on-error="onError"
          :on-remove="onRemove"
          :on-exceed="onExceed"
          :limit="1"
          :file-list="fileList"
          list-type="picture"
        >
          <el-button size="small" type="primary">Click to upload</el-button>
          <div slot="tip" class="el-upload__tip">jpg/jpeg/png files</div>
        </el-upload>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from 'vue2-editor'
import Preview from '@/global/components/Preview'

export default {
  components: {
    VueEditor,
    Preview
  },

  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      image: { name: '', url: '' },
      labelNameArtist: 'artist',
      form_community: {
        id: null,
        title: null,
        role: null,
        name: null,
        quote: null,
        post_link: null,
        position: null,
        image_url: null,
        featured: null
      }
    }
  },

  computed: {
    dialogTitle: function() {
      if (
        typeof this.community.id !== 'undefined' &&
        this.community.id !== null
      ) {
        return 'Edit Community'
      } else {
        return 'Insert Community'
      }
    },
    ...mapState('communityCarousel', [
      'loading',
      'community',
      'dialog',
      'artists'
    ])
  },

  methods: {
    ...mapActions('communityCarousel', ['update', 'insert']),
    ...mapMutations('communityCarousel', ['setDialog']),
    ...mapMutations('global', ['setPreview']),

    submit() {
      this.community.id = this.form_community.id
      this.community.title = this.form_community.title
      this.community.role = this.form_community.role
      this.community.name = this.form_community.name
      this.community.quote = this.form_community.quote
      this.community.post_link = this.form_community.post_link
      this.community.position = this.form_community.position
      this.community.image_url = this.form_community.image_url
      this.community.featured = this.form_community.featured
      this.clearForm()
      if (
        typeof this.community.id !== 'undefined' &&
        this.community.id !== null
      )
        this.update(this.community.id)
      else {
        this.insert()
      }
    },

    onSuccess(response, file) {
      this.form_community.image_url = response.response.message
      this.$message({
        type: 'success',
        message: `File ${file.name} uploaded`
      })
    },

    onError(err) {
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemove() {
      this.form_community.image_url = null
    },

    onExceed() {
      this.$message({
        type: 'error',
        message: 'Only one image can be uploaded'
      })
    },

    open() {
      this.fileList = []
      if (
        typeof this.community.image_url !== 'undefined' &&
        this.community.image_url !== null
      ) {
        this.image.url = this.community.image_url
        //this.image.name = this.image.url.substr(this.image.url.lastIndexOf("/")+1)
        this.fileList.push(this.image)
      }
      if (
        typeof this.community.id !== 'undefined' &&
        this.community.id !== null
      ) {
        this.form_community.id = this.community.id
        this.form_community.title = this.community.title
        this.form_community.role = this.community.role
        this.form_community.name = this.community.name
        this.form_community.quote = this.community.quote
        this.form_community.post_link = this.community.post_link
        this.form_community.position = this.community.position
        this.form_community.image_url = this.community.image_url
        this.form_community.featured = this.community.featured
      }
    },

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },

    clearForm() {
      this.form_community.id = null
      this.form_community.title = null
      this.form_community.role = null
      this.form_community.name = null
      this.form_community.quote = null
      this.form_community.post_link = null
      this.form_community.position = null
      this.form_community.image_url = null
      this.form_community.featured = null
    },

    close() {
      this.clearForm()
      this.setDialog(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.inline-eye {
  display: inline-block;
}
</style>
